
import React, { useState, useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/mqoelogo.png';
import { 
  Phone, 
  CheckCircle, 
  Menu, 
  X, 
  ChevronDown, 
  Facebook, 
  Instagram, 
  Linkedin,
  BookOpen,
  Users,
  Clock,
  Globe,
  ArrowRight
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const NooraniQaida = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);


   const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/#contact"); // Home page + hash
  };
  
  // Brand Color Palette
  const BRAND_GREEN = '#28a745'; 
  const DARK_GREEN = '#147a44';  
  const BG_CREAM = '#fdf8e1';    
  const COFFEE_BROWN = '#5d4a3e';

  // Load external assets
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Montserrat:wght@400;500;600;700&family=Inter:wght@300;400;600;700;800&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const fontAwesome = document.createElement('link');
    fontAwesome.rel = 'stylesheet';
    fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(fontAwesome);
  }, []);

  const serviceOptions = [
    { name: "Noorani Qaida", link: "/noorani" },
    { name: "Tajweed-e-Quran", link: "/tajweed" },
    { name: "Basic Islamic Educations", link: "/all" }
  ];

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }




     
  };

  return (
    <div className="min-h-screen text-[#333] overflow-x-hidden" style={{ backgroundColor: BG_CREAM, fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        :root {
            --primary-green: ${BRAND_GREEN};
            --dark-green: ${DARK_GREEN};
            --coffee: ${COFFEE_BROWN};
        }

        .nav-link {
            font-weight: 600;
            color: #1a3a2a;
            transition: all 0.3s;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: pointer;
            position: relative;
        }

        .nav-link::after {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 0;
            width: 0;
            height: 2px;
            background: var(--primary-green);
            transition: width 0.3s;
        }

        .nav-link:hover::after {
            width: 100%;
        }

       
        .dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            background: white;
            min-width: 240px;
            box-shadow: 0 15px 40px rgba(0,0,0,0.12);
            border-radius: 12px;
            padding: 12px 0;
            opacity: 0;
            visibility: hidden;
            transform: translateY(15px);
            transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
            border-top: 4px solid var(--primary-green);
            z-index: 50;
        }

        .group:hover .dropdown-menu {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }

        .glow-effect {
            position: relative;
        }

        .glow-effect::before {
            content: '';
            position: absolute;
            inset: -10px;
            background: radial-gradient(circle, rgba(40, 167, 69, 0.15) 0%, transparent 70%);
            border-radius: inherit;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s;
        }

        .glow-effect:hover::before {
            opacity: 1;
        }

        .floating {
            animation: float 4s ease-in-out infinite;
        }

        @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
        }

        .whatsapp-pulse {
            animation: pulse-green 2s infinite;
        }

        @keyframes pulse-green {
            0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
            70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
            100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
        }

        ::-webkit-scrollbar {
            width: 8px;
        }
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        ::-webkit-scrollbar-thumb {
            background: var(--primary-green);
            border-radius: 10px;
        }
      `}</style>

      {/* WhatsApp Link */}
      <a 
        href="https://wa.me/+923155141289" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-6 z-[1001] whatsapp-pulse bg-[#25D366] p-4 rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform active:scale-95"
      >
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.632 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>

      {/* Header */}
      {/* Header */}
     <header className="py-4 px-6 lg:px-24 bg-white fixed top-0 left-0 right-0 z-[1000] shadow-md">
  <div className="max-w-7xl mx-auto flex justify-between items-center">
    <div className="flex items-center gap-3">
      {/* Logo Section */}
      <div className="flex items-center">
        <img 
          src={logo} 
          alt="Madina Quran Online Education" 
          className="h-16 w-auto object-contain"
        />
      </div>
      
      {/* Brand Name */}
      <span className="text-sm md:text-lg lg:text-xl font-extrabold text-[#147a44]">
        Madina Quran Online Education
      </span>
      {/* Social Media Icons (Desktop) */}
    <div className="hidden md:flex items-center gap-4 ml-6">
      <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="#" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer"  className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
    </div>
    
    <nav className="hidden md:flex gap-10">
      <a href="/" className="nav-link">Home</a>
      
       {/* Desktop Dropdown */}
      <div className="relative group">
        <div className="nav-link cursor-pointer">
          Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
        </div>
        <div className="dropdown-menu">
          {serviceOptions.map((option, idx) => (
            <a 
  key={idx} 
  href={option.link} 
  className="block px-5 py-3 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-green-600 transition"
>
  {option.name}
</a>
          ))}
        </div>
      </div>

      <a href="/#contact" className="nav-link">Contact Us</a>
    </nav>

    

    <div className="md:hidden text-2xl cursor-pointer" onClick={toggleMenu}>
      <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
    </div>
  </div>
</header>


      {/* Mobile Nav */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-2xl z-[999] border-t"
          >
            <a href="#" className="nav-link py-3 border-b border-gray-100" onClick={() => setIsMenuOpen(false)}>Home</a>
            <div className="nav-link py-3 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
                Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
            </div>
            {isServicesOpen && (
                <div className="pl-4 flex flex-col space-y-3">
                    {serviceOptions.map((o, i) => <a key={i} href={o.link} className="text-sm font-medium text-gray-600">{o.name}</a>)}
                </div>
            )}
            <a href="#contact" className="nav-link py-3" onClick={() => setIsMenuOpen(false)}>Contact Us</a>

             {/* Social Media Icons (Mobile) */}
          <div className="flex gap-4 pt-3">
            <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F"><i className="fab fa-facebook-f text-gray-600"></i></a>
            <a href="#"><i className="fab fa-instagram text-gray-600"></i></a>
            <a href="#"><i className="fab fa-whatsapp text-gray-600"></i></a>
          </div>
          </motion.div>
        )}
      </AnimatePresence>

      <main className="max-w-6xl mx-auto px-6 lg:px-12 pt-32 pb-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center md:text-left mb-12">
            <span className="inline-block py-1 px-4 bg-green-100 text-green-700 rounded-full font-bold text-sm mb-4">Foundation Course</span>
            <h1 className="text-[40px] md:text-[64px] font-bold text-[#222] leading-tight" style={{ fontFamily: "'Libre Baskerville', serif" }}>
              Noorani Qaida <br />
              <span style={{ color: BRAND_GREEN }}>Starting Your Journey</span>
            </h1>
        </motion.div>

        {/* Hero Illustration Style Area */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative mb-24 rounded-[3rem] overflow-hidden shadow-2xl border-4 border-white aspect-[16/9] md:aspect-[21/9]"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-green-600 to-emerald-900 flex items-center justify-center">
            <div className="relative z-10 text-center px-4">
                <BookOpen size={80} className="text-white/20 absolute top-12 -left-12 rotate-[-15deg]" />
                <h2 className="text-white text-3xl md:text-5xl font-bold mt-2 mb-4 drop-shadow-lg">Basic Quranic Foundation</h2>
                <p className="text-green-100 text-lg md:text-xl max-w-2xl mx-auto font-medium">The essential first step for children and beginners to master Arabic phonetics and pronunciation.</p>
                <div className="mt-4 flex flex-wrap justify-center gap-4">
                    <div className="bg-white/10 backdrop-blur-md px-6 py-2 rounded-full text-white border border-white/20 flex items-center gap-2">
                        <CheckCircle size={18} /> Correct Pronunciation
                    </div>
                    <div className="bg-white/10 backdrop-blur-md px-6 py-2 rounded-full text-white border border-white/20 flex items-center gap-2">
                        <CheckCircle size={18} /> Arabic Alphabet
                    </div>
                </div>
            </div>
            {/* Geometric Decorative Elements */}
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mb-20 blur-3xl"></div>
            <div className="absolute top-0 left-0 w-64 h-64 bg-green-400/10 rounded-full -ml-20 -mt-20 blur-3xl"></div>
          </div>
        </motion.div>

        {/* Introduction Section */}
        <div className="grid md:grid-cols-2 gap-16 mb-24 items-center">
            <motion.div variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Libre Baskerville', serif", color: DARK_GREEN }}>
                    What is Noorani Qaida?
                </h2>
                <p className="text-[#555] text-lg leading-relaxed mb-6">
                    Noorani Qaida is a fundamental book for beginners to learn the Quranic Arabic. It is specifically designed to teach the rules of pronunciation (Tajweed) from the very basics. 
                </p>
                <p className="text-[#555] text-lg leading-relaxed mb-8 font-medium">
                    At Madina Quran Online Academy, we provide interactive one-on-one sessions that ensure every student masters the alphabet, word formation, and basic reading rules before moving to the Holy Quran.
                </p>
                <div className="space-y-4">
                    {["Step-by-step learning methodology", "Focus on Makharij (Articulation points)", "Kid-friendly teaching environment", "Qualified male & female tutors"].map((t, i) => (
                        <div key={i} className="flex items-center gap-3 font-semibold text-gray-700">
                            <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white">
                                <CheckCircle size={14} strokeWidth={4} />
                            </div>
                            {t}
                        </div>
                    ))}
                </div>
            </motion.div>
            <motion.div 
                initial={{ opacity: 0, x: 40 }} 
                whileInView={{ opacity: 1, x: 0 }} 
                viewport={{ once: true }}
                className="bg-white p-8 rounded-[2.5rem] shadow-xl border border-green-50 relative overflow-hidden"
            >
                <div className="absolute top-0 right-0 p-8 opacity-10">
                    <Globe size={120} className="text-green-800" />
                </div>
                <h3 className="text-2xl font-bold mb-8 text-green-800">Course Highlights</h3>
                <div className="grid grid-cols-1 gap-6">
                    {[
                        { icon: <Users />, title: "Personalized Coaching", desc: "Individual attention to correct specific pronunciation errors." },
                        { icon: <Clock />, title: "Flexible Timing", desc: "Choose class times that fit your school or work schedule." },
                        { icon: <ArrowRight />, title: "Interactive Lessons", desc: "Engaging digital tools to keep kids interested and motivated." }
                    ].map((item, idx) => (
                        <div key={idx} className="flex gap-5 group">
                            <div className="w-14 h-14 bg-green-50 rounded-2xl flex items-center justify-center text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all duration-300 shadow-sm">
                                {item.icon}
                            </div>
                            <div>
                                <h4 className="font-bold text-lg text-gray-800">{item.title}</h4>
                                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </div>

        {/* Curriculum Section */}
        <motion.div 
            initial="hidden" 
            whileInView="visible" 
            viewport={{ once: true }} 
            variants={staggerContainer}
            className="text-center mb-24"
        >
            <h2 className="text-3xl md:text-4xl font-bold mb-12" style={{ fontFamily: "'Libre Baskerville', serif", color: DARK_GREEN }}>
                Noorani Qaida Curriculum
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                    { step: "01", title: "Single Letters", desc: "Learning the Alif-Ba-Ta with correct Makharij." },
                    { step: "02", title: "Joined Letters", desc: "Recognizing letters in their different shapes." },
                    { step: "03", title: "Vowels", desc: "Fatha, Kasra, and Damma (Harakat) basics." },
                    { step: "04", title: "Advanced Rules", desc: "Madd, Sukoon, and Shaddah mastery." }
                ].map((step, idx) => (
                    <motion.div 
                        key={idx} 
                        variants={fadeInUp}
                        className="bg-white p-8 rounded-3xl shadow-md border-b-4 border-green-500 hover:-translate-y-2 transition-transform"
                    >
                        <span className="text-4xl font-black text-green-100 block mb-2">{step.step}</span>
                        <h4 className="font-bold text-lg mb-2 text-gray-800">{step.title}</h4>
                        <p className="text-xs text-gray-500 font-medium leading-relaxed">{step.desc}</p>
                    </motion.div>
                ))}
            </div>
        </motion.div>

        {/* Why Us Section */}
        <div className="bg-[#1a3a2a] rounded-[3rem] p-10 md:p-20 text-white mb-24 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 -skew-x-12 translate-x-20"></div>
            <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Libre Baskerville', serif" }}>
                        Why Choose Our Academy?
                    </h2>
                    <p className="text-green-100/80 text-lg leading-relaxed mb-8">
                        We understand that the first step is the hardest. Our teachers are trained specifically in "Pedagogy for Kids" to make Arabic learning fun and rewarding.
                    </p>
                    <div className="grid grid-cols-2 gap-6">
                        <div className="border-l-2 border-green-500 pl-4">
                            <div className="text-3xl font-bold">5000+</div>
                            <div className="text-green-400 text-sm font-bold uppercase tracking-wider">Students</div>
                        </div>
                        <div className="border-l-2 border-green-500 pl-4">
                            <div className="text-3xl font-bold">100%</div>
                            <div className="text-green-400 text-sm font-bold uppercase tracking-wider">Satisfaction</div>
                        </div>
                    </div>
                </div>
                <div className="bg-white/10 backdrop-blur-xl p-8 rounded-3xl border border-white/10">
                    <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
                        <CheckCircle className="text-green-400" /> Enrollment Process
                    </h3>
                    <ul className="space-y-6">
                        <li className="flex gap-4">
                            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shrink-0 font-bold">1</div>
                            <p>Contact us via WhatsApp or Phone to book a slot.</p>
                        </li>
                        <li className="flex gap-4">
                            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shrink-0 font-bold">2</div>
                            <p>Take a 3-Day Free Trial class with our expert tutor.</p>
                        </li>
                        <li className="flex gap-4">
                            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shrink-0 font-bold">3</div>
                            <p>Start your regular journey towards Quranic excellence.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* Contact/CTA */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-2xl border border-gray-100 max-w-3xl mx-auto overflow-hidden relative text-center"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full"></div>
          <h3 className="text-[28px] md:text-[36px] font-bold mb-6" style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}>
            Start Your Free Trial Today
          </h3>
          <p className="text-[#555] text-lg mb-10 max-w-xl mx-auto">
            Give your children the gift of Quranic education. Join students from across Pakistan, UK, USA, and Canada.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <motion.a 
                href="tel:+923155141289"
                whileHover={{ scale: 1.05 }}
                className="w-full md:w-auto bg-green-600 text-white px-10 py-4 rounded-2xl font-bold flex items-center justify-center gap-2 shadow-lg"
            >
                <Phone size={20} /> +92 315 5141289
            </motion.a>
            <motion.button 
                whileHover={{ scale: 1.05 }}
                className="w-full md:w-auto bg-[#25D366] text-white px-10 py-4 rounded-2xl font-bold flex items-center justify-center gap-2 shadow-lg"
            >
               <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer" className="whatsapp-float"> <i  className="fab fa-whatsapp text-xl"></i> WhatsApp Us</a>
            </motion.button>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      {/* <footer className="bg-white border-t border-gray-100 mt-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 grid md:grid-cols-3 gap-16 lg:gap-24">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
               <div className="w-10 h-10 bg-green-600 rotate-45 flex items-center justify-center rounded-lg shadow-lg">
                  <span className="rotate-[-45deg] text-[10px] font-black text-white">MQE</span>
               </div>
               <span className="text-2xl font-black tracking-tighter" style={{ color: BRAND_GREEN }}>MADINA QURAN</span>
            </div>
            <p className="text-[#888] text-[15px] leading-[1.9] font-medium">
              Dedicated to spreading the light of Quranic knowledge through modern online learning platforms. Making Quran education accessible to everyone, everywhere.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Our Courses</h4>
              <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
                <li><a href="#" className="hover:text-green-600 transition-colors">Noorani Qaida</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Tajweed Quran</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Hifz-e-Quran</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Arabic Language</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Academy</h4>
              <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
                <li><a href="#" className="hover:text-green-600 transition-colors">About Us</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Contact</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Fee Structure</a></li>
                <li><a href="#" className="hover:text-green-600 transition-colors">Free Trials</a></li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Join Community</h4>
            <div className="flex gap-4">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <motion.a 
                  key={i} 
                  whileHover={{ y: -5, backgroundColor: BRAND_GREEN, color: '#fff', borderColor: BRAND_GREEN }}
                  href="#" 
                  className="w-12 h-12 border border-gray-200 rounded-2xl flex items-center justify-center text-[#999] transition-all bg-white shadow-sm"
                >
                  <Icon size={22} />
                </motion.a>
              ))}
            </div>
            <p className="mt-8 text-[#999] text-sm italic font-medium">Serving the Muslim Ummah Worldwide since 2022.</p>
          </div>
        </div>

        <div className="bg-[#5d4a3e] py-8 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-white/5 opacity-10"></div>
          <p className="text-white text-[12px] font-bold tracking-widest relative z-10 opacity-90 uppercase">
            © 2022-2025 Madina Quran Online Academy. Spread the Light.
          </p>
        </div>
      </footer> */}
    </div>
  );
};

export default NooraniQaida;